<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="On Hold Balance"
            bc1="App"
            bc2="Hold Balance"
            bc3="List"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
              type="button"
              class="btn btn-gradient-danger btn-sm"
              @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
        <div
          class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class=" d-flex justify-content-end">
            <div class="col-md-4" >
              <SelectOptions
                  label=""
                  selectAppend="transaction type"
                  labelValue="name"
                  :modelValue.sync="selectedType"
                  url="v1/transaction-types"
              />
            </div>
          </div>
          <LoadMoreCommonTable
            url="v1/get-ledger"
            :filteredData="filteredData"
            :tableHeaderValues="tableHeaderValues"
            :actions="[]"
            :deleteActions="[]"
            :mutedData="[]"
            :storageKey="storageKey"
            :externalTotalRecord="externalTotalRecord"
            :loadMore="true"
            :showPerPage="true"
            :alterResponseData="alter"
            @perPageFilterChanged="perPageFilterChanged"
            @getFullResponse="getFullResponse"
          >
          <!-- <template  v-slot:additionalFilter>
              <div class="col-12 d-flex mb-1  justify-content-center" v-if="filterLoader">
                <div class="spinner-border text-primary"></div>
              </div>
              <div class="row pt-0 pb-2 mx-50" v-show="!filterLoader">
                <div class=" mr-2 ">
                  <date-picker
                      v-model="fromDate"
                      valueType="format"
                      :lang="lang"
                      name="fromDate"
                      placeholder="choose start date"
                  ></date-picker>
                </div>
                <div class=" mr-2 ">
                  <date-picker
                      v-model="toDate"
                      valueType="format"
                      :lang="lang"
                      name="toDate"
                      placeholder="choose end date"
                  ></date-picker>
                </div>
                <div class=" mr-2 mb-25" >
                  <select class="form-control" v-model="selectedChannel">
                    <option :value="null">Select Channel</option>
                    <option :key="index" v-for="(item,index) in channelData" :value="item.id">{{ item.name+'/'+item.code }}</option>
                  </select>
                </div>
                <div class=" mr-2  mt-25">
                  <button type="button" class="btn btn-primary btn-sm" @click="onSubmitFilters" >Submit</button>
                  <button type="button" class="ml-1 btn btn-dark btn-sm "  @click="clear">Clear</button>
                </div>
              

              </div>
            </template> -->
        </LoadMoreCommonTable>
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import DatePicker from "vue2-datepicker";
export default {
  components:{
    DatePicker:DatePicker
  },
  mounted() {
    localStorage.setItem("url", "v1/get-ledger");
    this.checkDataInStore('v1/get-ledger')
    if (
      typeof this.$route.params.update == "undefined" &&
      typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
    // this.getChannelData()
  },
  data() {
    return {
      alter:{
        alter: (value) => {
          if(value){
            if(value.data){
              let temp = []
              value.data.forEach((eachArrayItem,index)=>{

                

                if(typeof(value.fullResponse.closingBalance) != 'undefined' && index == 0 && value.pagination.currentPage == 1){
                  this.orignalGivenClosingBalance = value.fullResponse.closingBalance
                  this.lastClosingBalance = this.orignalGivenClosingBalance

                  eachArrayItem.closing_balance = this.lastClosingBalance

                  if(eachArrayItem.type == 1){
                    //credit
                    
                    this.lastClosingBalance = parseFloat(this.lastClosingBalance) -  parseFloat(eachArrayItem.total_amount)

                  }else{
                    
                    this.lastClosingBalance = parseFloat(this.lastClosingBalance) +  parseFloat(eachArrayItem.total_amount)
                  }

                }else{
                  eachArrayItem.closing_balance = this.lastClosingBalance

                  if(eachArrayItem.type == 1){
                    //credit
                    
                    this.lastClosingBalance = parseFloat(this.lastClosingBalance) -  parseFloat(eachArrayItem.total_amount)

                  }else{
                   
                    this.lastClosingBalance = parseFloat(this.lastClosingBalance) +  parseFloat(eachArrayItem.total_amount)
                  }


                }


             

                temp.push(eachArrayItem)
              })
              value.data = temp
             
            }
          }

          return value
        }
      },
      filterLoader:false,
      lastClosingBalance:0,
      orignalGivenClosingBalance:0,
      externalTotalRecord: "",
      fromDate: null,
      toDate: null,
      channelLoader:false,
      channelData:[],
      selectedChannel:null,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      storageKey: "account-ledger-bal",
      accountId: null,
      selectdValet: null,
      filteredData:{userAccountId : parseInt(this.$route.params.id),balanceOnHold:1 },
      valetData: [],
      tableHeaderValues: [
       
        {
          title: 'Fees',
          valueKey: 'fee',
          alter: (value) => {
            return parseFloat(value/100).toFixed(this.feesDecimalPlaces)


          }
        },
        {
          title: 'Vat',
          valueKey: 'vat',
          alter: (value) => {
            return parseFloat(value/100).toFixed(this.feesDecimalPlaces)


          }
        },
        {
          title: 'Amount',
          valueKey: 'amount',
          alter: (value) => {
            return this.modifyAmount(parseFloat(value/100).toFixed(this.amountDecimalPlaces))


          }
        },

        {
          title: 'Debit Amount',
          valueKey: 'total_amount',
          html: true,
          alter:  (value,obj) => {
            var  html = `<span style="font-size: larger" class=" font-weight-bolder text-danger">-</span>`
            if(obj.type == 0)
            html = `<span style="font-size: larger" class=" font-weight-bolder text-danger">${this.modifyAmount(parseFloat(value / 100).toFixed(this.amountDecimalPlaces))}</span>`
            
            
            if ((value / 100) == 0) {
              html = `<span style="font-size: larger" class=" font-weight-bolder text-danger">-</span>`
            }

            return html

          }
        },
        {
          title: 'Credit Amount',
          valueKey: 'total_amount',
          html: true,
          alter:  (value,obj) => {
            var html = `<span style="font-size: larger" class=" font-weight-bolder text-success">-</span>`
            if(obj.type == 1)
            html = `<span style="font-size: larger" class=" font-weight-bolder text-success">${this.modifyAmount(parseFloat(value / 100).toFixed(this.amountDecimalPlaces))}</span>`
            if ((value / 100) == 0) {
              html = `<span style="font-size: larger" class=" font-weight-bolder text-success">-</span>`
            }
            return html

          }
        },
    
        {
          title: 'Closing Balance',
          valueKey: 'closing_balance',
          alter:  (value) => {
            let res = this.modifyAmount(parseFloat(value/100).toFixed(8),8)
            if(res == '-0.000'){
              res = this.modifyAmount(parseFloat(0/100).toFixed(8),8)
            } 
            return res
          }
        },
        {
          title: 'Transaction Type',
          valueKey: 'transaction_type.name',
          html: true,
          alter:  (value,row)  => {
            var html = ''
            if (value)
              html = ` <a href="javascript:void()" class="badge light badge-light-primary ">${value}</a>`

            if(row.type_id){
              html = `
                <div class="row">
                    <div class="col-12 text-center">
                        <div>${html}</div>
                        <div class="badge badge-light-dark mt-1 font-small-1">${row.type_id}</div>
                    </div>
                </div>
                `
            }


            return html


          }
        },
        {
          title: 'Currency',
          valueKey: 'user_account.currency.code',
          html: true,
          alter: function (value) {
            var html = ''
            html = ` <a href="javascript:void()" class="badge badge-circle badge-light-success badge-glow">${value}</a>`

            return html


          }
        },
        {
          title: 'Transaction Time/Date',
          titleHtml: `<br> <span class="text-warning font-weight-bolder">
														(Showing In GMT)
													</span>`,
          valueKey: 'created_at',
          alter: (value) => {
            return new Date(value).toISOString().slice(0, 16).replace('T', ' ')
          }
        },
      ],
      actions: [],
      selectedType: null,
    }
  },
  methods: {
    getFullResponse(response) {
      this.filterLoader = false
    },
    perPageFilterChanged(){
      this.lastClosingBalance = this.orignalGivenClosingBalance
    },
    onSubmitFilters() {
      this.filterLoader = true
      let filterData = {userAccountId : parseInt(this.$route.params.id),balanceOnHold:1}

      if(this.selectedType){
        filterData.transactionTypeId = this.selectedType.id
      }
      if(this.selectedChannel){
        filterData.channelId = this.selectedChannel
      }

      if(this.toDate){
        filterData.toDate = this.toDate
      }
      if(this.fromDate){
        filterData.fromDate = this.fromDate
      }



      this.filteredData = filterData




    },
    clear(){
      this.filterLoader = true
      this.toDate = null
      this.fromDate = null
      this.selectedChannel = null
      let filterData = {userAccountId : parseInt(this.$route.params.id),balanceOnHold:1}
      if(this.selectedType){
        filterData.transactionTypeId = this.selectedType.id
      }
      this.filteredData = filterData

    },
  },
  watch:{
    selectedType(val){
      this.lastClosingBalance = 0
      if(val){
        this.filteredData = {
          userAccountId : parseInt(this.$route.params.id),
          balanceOnHold:1,
          transactionTypeId: val.id
        }
      }else{
        this.filteredData = {userAccountId : parseInt(this.$route.params.id),balanceOnHold:1 }
      }

    }
  }

}
</script>

